import { useRef, useState } from 'react';

import { DotsIcon } from '../../../../assets/svg/DotsIcon';
import { useClickOutside } from '../../../../hooks/useClickOutside';
import { useMerchant } from '../../../../hooks/useMerchant';
import { PaymentMultiuse } from '../../../../models/payment-links-multiuse';
import { hasPermission } from '../../../../utils/common';
import { SimpleButton } from '../table/styles';
import { DropdownContainer, DropdownItem, DropdownList } from './styles';

interface Options {
	label: string;
	onClick: (rowData: PaymentMultiuse) => void;
	colorCustom?: string;
}

interface DropdownProps {
	options: Options[];
	disabled?: boolean;
	rowData: PaymentMultiuse;
}

const Dropdown = ({ options, disabled, rowData }: DropdownProps) => {
	const [isDropdownVisible, setIsDropdownVisible] = useState<boolean>(false);
	const { merchantSelected } = useMerchant();
	const modal = useRef<HTMLDivElement>(null);

	const toggleDropdown = () => {
		setIsDropdownVisible(!isDropdownVisible);
	};

	const handleItemClick = (onClick: (rowData: PaymentMultiuse) => void) => {
		onClick(rowData);
		setIsDropdownVisible(false);
	};

	useClickOutside({ elementRef: modal, callback: () => setIsDropdownVisible(false) });

	if (
		hasPermission('PL_MULTIUSE_EDIT', merchantSelected?.role_permissions) &&
		hasPermission('PL_MULTIUSE_END', merchantSelected?.role_permissions)
	) {
		return (
			<SimpleButton onClick={toggleDropdown}>
				{disabled && <DotsIcon />}
				{isDropdownVisible && (
					<DropdownContainer ref={modal}>
						<DropdownList>
							{options?.map(({ label, onClick, colorCustom }) => (
								<DropdownItem
									key={label}
									onClick={() => handleItemClick(onClick)}
									colorCustom={colorCustom}
								>
									{label}
								</DropdownItem>
							))}
						</DropdownList>
					</DropdownContainer>
				)}
			</SimpleButton>
		);
	} else {
		return null;
	}
};

export { Dropdown };
